module.exports = __webpack_public_path__ + "static/img/active-course.9f1db4b6.png";